export default __webpack_public_path__ + "static/media/Aman_Image.ca911b37.jpg";